import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { SystemConfig } from './config/SystemConfig';
import { ThemeProvider } from './context/ThemeContext';

const applyGlobalConfig = () => {
  if (SystemConfig.browserTitle) {
    document.title = SystemConfig.browserTitle;
  }

  const iconLink = document.querySelector("link[rel*='icon']");
  if (iconLink) {
    iconLink.href = process.env.PUBLIC_URL + SystemConfig.logoPath;
  }

  const appleIconLink = document.querySelector("link[rel='apple-touch-icon']");
  if (appleIconLink) {
    appleIconLink.href = process.env.PUBLIC_URL + SystemConfig.logoPath;
  }
};



applyGlobalConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);